import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { formatCurrency } from "../../../utils";
import ReportHeader from "./ReportHeader";
import ReportFooter from "./ReportFooter";

const CashFlowReportOfficePDF = ({ isPdf = false, selectedMonth = "", fetchData }: { isPdf?: boolean; selectedMonth?: string; fetchData: any }) => {
  return (
    <div className="break-page-before">
      <div className={`${isPdf ? "w-full h-a4-finance relative" : ""}`}>
        {isPdf ? (
          <ReportHeader title="Cash Flow" selectedMonth={selectedMonth} />
        ) : (
          <div className="w-full flex items-center justify-center p-2 bg-docsigna-purple-dark">
            <h3 className="text-lg font-semibold text-white font-roboto-regular">Cash Flow</h3>
          </div>
        )}
        <div className={`${!isPdf ? "border-2 border-t-0 border-docsigna-blue-light" : ""} px-5 py-8`}>
          <div className="grid grid-cols-4">
            <div className="col-span-2">
              <p className="font-roboto-regular text-sm">Credits</p>
            </div>
            <div></div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2 mb-3">
            <div className="col-span-2"></div>
            <div>
              <p className="font-roboto-regular text-sm">Forms With HST</p>
            </div>
            <div>
              <p className="font-roboto-regular text-sm">Forms Without HST</p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Revenue Collected by Docnote</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstDsFeeSubTotal !== undefined
                  ? formatCurrency((fetchData?.withHstDsFeeSubTotal / 100)?.toString(), "blur")
                  : "$0.00"}
              </p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withoutHstDsFeeSubTotal !== undefined
                  ? formatCurrency((fetchData?.withoutHstDsFeeSubTotal / 100)?.toString(), "blur")
                  : "$0.00"}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light ml-3">HST on above item</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstTotal !== undefined ? formatCurrency((fetchData?.withHstTotal / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">N/A</p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Total Credits Collected by Docnote</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstTotalCredits !== undefined ? formatCurrency((fetchData?.withHstTotalCredits / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withoutHstTotalCredits !== undefined
                  ? formatCurrency((fetchData?.withoutHstTotalCredits / 100)?.toString(), "blur")
                  : "$0.00"}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-2 mb-2 mt-3">
            <div className="col-span-2">
              <p className="font-roboto-regular text-sm">Debits</p>
            </div>
            <div></div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Doctors DN fee</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstDoctorDsFee !== undefined ? formatCurrency((fetchData?.withHstDoctorDsFee / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Patient DN fee collection by office</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstPatientDsFee !== undefined ? formatCurrency((fetchData?.withHstPatientDsFee / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light ml-3">HST on above fees</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstDebits !== undefined ? formatCurrency((fetchData?.withHstDebits / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Total Debits Owed to Docnote</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">
                {fetchData?.withHstTotalDebits !== undefined ? formatCurrency((fetchData?.withHstTotalDebits / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2 mb-2 mt-3">
            <div className="col-span-2">
              <p className="font-roboto-regular text-sm">Refunds (Credits)</p>
            </div>
            <div></div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Collected by Docnote</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">$0.00</p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light ml-3">HST on above item</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">$0.00</p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2">
            <div className="col-span-2">
              <p className="font-13 font-roboto-light">Total Refunds as Credits</p>
            </div>
            <div>
              <p className="font-13 font-roboto-light">$0.00</p>
            </div>
            <div></div>
          </div>
          <div className="grid grid-cols-4 gap-2 mt-5">
            <div className="col-span-2">
              <p className="font-roboto-regular text-sm">Net Payable to Doctor</p>
            </div>
            <div>
              <p className="font-roboto-regular text-sm">
                {fetchData?.netPayableToDoctor !== undefined ? formatCurrency((fetchData?.netPayableToDoctor / 100)?.toString(), "blur") : "$0.00"}
              </p>
            </div>
            <div></div>
          </div>
          {/* Part second */}
          <div className={`w-full flex justify-center py-5 ${isPdf ? "mt-3" : ""}`}>
            <hr className="w-8/12 border-docsigna-blue-dark" />
          </div>
          <div>
            <div className="grid grid-cols-4">
              <div className="col-span-2">
                <p className="font-roboto-regular text-sm">Collected By Office</p>
              </div>
              <div></div>
              <div></div>
            </div>
            <div className="grid grid-cols-4 gap-2 mb-3">
              <div className="col-span-2"></div>
              <div>
                <p className="font-roboto-regular text-sm">Forms With HST</p>
              </div>
              <div>
                <p className="font-roboto-regular text-sm">Forms Without HST</p>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-2">
              <div className="col-span-2">
                <p className="font-13 font-roboto-light">Revenue Collected by Office</p>
              </div>
              <div>
                <p className="font-13 font-roboto-light">
                  {fetchData?.withHstRevenueCollectedByOffice !== undefined
                    ? formatCurrency((fetchData?.withHstRevenueCollectedByOffice / 100)?.toString(), "blur")
                    : "$0.00"}
                </p>
              </div>
              <div>
                <p className="font-13 font-roboto-light">
                  {fetchData?.withoutHstRevenueCollectedByOffice !== undefined
                    ? formatCurrency((fetchData?.withoutHstRevenueCollectedByOffice / 100)?.toString(), "blur")
                    : "$0.00"}
                </p>
              </div>
            </div>
            <div className="grid grid-cols-4 gap-2">
              <div className="col-span-2">
                <p className="font-13 font-roboto-light ml-3">HST on above item</p>
              </div>
              <div>
                <p className="font-13 font-roboto-light">
                  {fetchData?.withHstRevenueCollectedByOfficeHstCalculated !== undefined
                    ? formatCurrency((fetchData?.withHstRevenueCollectedByOfficeHstCalculated / 100)?.toString(), "blur")
                    : "$0.00"}
                </p>
              </div>
              <div>
                <p className="font-13 font-roboto-light">N/A</p>
              </div>
            </div>
          </div>
        </div>

        {isPdf ? <ReportFooter /> : null}
      </div>
    </div>
  );
};

export default CashFlowReportOfficePDF;
